<!-- Main header with toolbar -->
<header>
  <mat-toolbar color="primary" class="app-toolbar" [class.dev-marker]="!isProduction">

    <!-- Logo and branding -->
    <a routerLink="/dashboard" class="logo-wrapper">
      <img class="app-logo" src="assets/images/hka-app-logo.svg" height="48px" alt="HKA Logo" />
      <span class="app-title">HKA-APP</span>
    </a>

    <!-- Desktop navigation -->
    <nav *ngIf="localStorage.getItem('authToken')" class="desktop-nav">

      <!-- Navigation links -->
      <a mat-button routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
      <a mat-button routerLink="/newscategory" routerLinkActive="active">News-Kategorien</a>
      <a mat-button routerLink="/courses" routerLinkActive="active">Studiengänge</a>

      <!-- Campus dropdown menu -->
      <button mat-button [matMenuTriggerFor]="campusMenu" routerLinkActive="active">
        Campus
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #campusMenu="matMenu">
        <a mat-menu-item routerLink="/searchgeneral" (click)="closeSidenav()">
          <mat-icon>info</mat-icon>
          <span>Allgemein</span>
        </a>
        <a mat-menu-item routerLink="/searchcampus" (click)="closeSidenav()">
          <mat-icon>location_on</mat-icon>
          <span>Gebäude</span>
        </a>
        <a mat-menu-item routerLink="/searchstudentunion" (click)="closeSidenav()">
          <mat-icon>groups</mat-icon>
          <span>Fachschaften</span>
        </a>
        <a mat-menu-item routerLink="/searchoffice" (click)="closeSidenav()">
          <mat-icon>domain</mat-icon>
          <span>Sekreteriate</span>
        </a>
        <a mat-menu-item routerLink="/searchroom" (click)="closeSidenav()">
          <mat-icon>door_sliding</mat-icon>
          <span>Räume</span>
        </a>
      </mat-menu>

      <!-- Plans and lists dropdown menus -->
      <button mat-button [matMenuTriggerFor]="planMenu" routerLinkActive="active">
        Pläne und Listen
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #planMenu="matMenu">
        <a mat-menu-item routerLink="/plan/semesterschedule" (click)="closeSidenav()">
          <mat-icon>calendar_today</mat-icon>
          <span>Terminplan</span>
        </a>
        <a mat-menu-item routerLink="/plan/scsl" (click)="closeSidenav()">
          <mat-icon>assignment</mat-icon>
          <span>Aufgabenplan</span>
        </a>
        <a mat-menu-item routerLink="/plan/modifycourses" (click)="closeSidenav()">
          <mat-icon>edit</mat-icon>
          <span>Kurse bearbeiten</span>
        </a>
        <a mat-menu-item routerLink="/plan/ignoreSemesters" (click)="closeSidenav()">
          <mat-icon>skip_next</mat-icon>
          <span>Semester ignorieren</span>
        </a>
      </mat-menu>

      <!-- Analytics link -->
      <a mat-button routerLink="/analytics" routerLinkActive="active">
        Analytics
      </a>
    </nav>

    <!-- Spacer to push navigation to the right -->
    <span class="spacer"></span>

    <!-- External links and logout button (Desktop) -->
    <nav class="desktop-nav">
      <a mat-icon-button href="https://web.hka.app/" target="_blank" matTooltip="WebApp">
        <mat-icon>public</mat-icon>
      </a>
      <a mat-icon-button href="https://linktr.ee/hka_app" target="_blank" matTooltip="Linktree">
        <img src="assets/images/linktree-white-icon.png" alt="Linktree" class="icon-image" />
      </a>
      <button *ngIf="localStorage.getItem('authToken')" mat-icon-button (click)="logout()" matTooltip="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    </nav>
  </mat-toolbar>
</header>
